/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsBoolResponse
 */
export interface IdentityMelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IdentityMelcoModelsBoolResponse
     */
    result?: boolean;
}

export function IdentityMelcoModelsBoolResponseFromJSON(json: any): IdentityMelcoModelsBoolResponse {
    return IdentityMelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function IdentityMelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function IdentityMelcoModelsBoolResponseToJSON(value?: IdentityMelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


